import { Component, OnInit } from '@angular/core';
import { UserService } from '../../../core/services/user.service';
import { TenantLogoHelper } from '../../../utils/helpers/tenant-logo.helper';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  tenantLogoUrl: string;

  constructor(private userService: UserService) { }

  ngOnInit(): void {
    this.tenantLogoUrl = TenantLogoHelper.getLogoUrl();
  }

  logout() {
    this.userService.logout();
  }

}
